var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleChassis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.833 6.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2,29.085,17.411,26.75H8.536L7.049,28.609a.3.3,0,0,1-.231.111H5.465l-.715,2.5V33.25H7.325a3.053,3.053,0,0,1,6.078,0h5.74a3.053,3.053,0,0,1,6.078,0h3.363V31.72Zm-4.2.422H13.909a.3.3,0,0,1-.264-.163l-.788-1.576a.3.3,0,0,1,.264-.427h3.545a.3.3,0,0,1,.1.018L21.1,28.934a.3.3,0,0,1-.1.573Z",
    transform: "translate(-4.75 -26.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleChassis);
export default __webpack_public_path__ + "static/media/VehicleChassis.659feb7677b9c77d59fb13ddd1bdb192.svg";
export { ForwardRef as ReactComponent };